import { Component, Input } from '@angular/core';
// import fetch from 'node-fetch';
/**
 * Generated class for the CoInstagramComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-instagram',
  templateUrl: 'co-instagram.html',
  inputs: ['blockInfo']
})
export class CoInstagramComponent {
  @Input() blockInfo: any;
  text: string;

  constructor() {
    // console.log('Hello CoInstagramComponent Component');
    this.text = 'Hello World';
  }

  // ngOnInit() {
  //   fetch('https://api.instagram.com/oembed?url=http://instagr.am/p/fA9uwTtkSN/&omitscript=true&callback=instaCallback', {
  //     method: 'GET'
  //   }).then((res) => {
  //     console.log(res)
  //   }).catch((err) => {
  //     console.log('woops', err)
  //   });
  // }

  instaCallback(){
    // console.log('wee woo called')
  }

}



// WEBPACK FOOTER //
// ./src/components/co-instagram/co-instagram.ts